import styled from "styled-components";

export const $RatingTypeTemplateContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 127px;
`;
